<div class="user-chat w-100 overflow-hidden" style="min-height: 335px;">
  <div class="chat-content d-lg-flex">
    <div class="w-100 overflow-hidden position-relative">
      <div class="position-relative">
        <div class="position-relative" id="users-chat">
          <ngx-simplebar class="chat-conversation p-2" #scrollRef>
            @if (loading) {
              <div class="d-flex align-items-center justify-content-center" style="height: 25vh;">
                <app-loading-spinner></app-loading-spinner>
              </div>
            }
            <ul class="list-unstyled chat-conversation-list" id="users-conversation">
              @for (data of chatMessagesData; track data; let i = $index) {
                <li class="chat-list" [ngClass]="data.role === 'assistant' ? 'left' : 'right'">
                  <div class="conversation-list">
                    @if (data.role === 'assistant') {
                      <div class="chat-avatar">
                        <img src="{{ pchat }}" alt="">
                      </div>
                    }
                    <div class="user-chat-content">
                      <div class="ctext-wrap">
                        <div class="ctext-wrap-content">
                          @if (!data.loading && data.content) {
                            <p class="mb-0 ctext-content" [ngClass]="chat_lang === 'he' ? 'rtl text-end' : ''">
                              {{ data.content }}
                              @if (data.description) {
                                <i class="ri-information-fill align-bottom" [ngbTooltip]="data.description"></i>
                              }
                            </p>
                          }
                          @if (!data.loading && data.buttons && data.buttons.length > 0) {
                            <ul class="list-group mt-2">
                              @for (button of data.buttons; track button) {
                                <li class="pointer list-group-item list-group-item-action list-group-item-info" (click)="handleButtonClick(button)">
                                  {{ button.name }}
                                  @if (button.description) {
                                    <i class="ri-information-fill align-bottom" [ngbTooltip]="button.description"></i>
                                  }
                                </li>
                              }
                            </ul>
                          }
                          @if (!data.loading && data.intervals && data.intervals.length > 0) {
                            <ul class="intervals-inline mt-3">
                              @for (interval of data.intervals; track interval; let i = $index) {
                                <li class="interval-item list-group-item list-group-item-action list-group-item-secondary pointer badge-container" (click)="onTimestampClick(interval[0], i)">
                                  @if (data.full_intervals_list && data.full_intervals_list[1] && data.full_intervals_list[1][i] && data.full_intervals_list[1][i].length > 0) {
                                    <span class="badge bg-info">
                                      {{ data.full_intervals_list[1][i].length }}
                                    </span>
                                  }
                                  {{ convertToTimerFormat(interval[0]) + ' - ' + convertToTimerFormat(interval[1]) }}
                                </li>
                              }
                            </ul>
                          }
                          @if (selected_index !== null && data.full_intervals_list && data.full_intervals_list[1] && data.full_intervals_list[1][selected_index] && data.full_intervals_list[1][selected_index].length > 0) {
                            <hr>
                            }
                            @if (selected_index !== null && data.full_intervals_list && data.full_intervals_list[1] && data.full_intervals_list[1][selected_index] && data.full_intervals_list[1][selected_index].length > 0) {
                              <p class="mb-0 ctext-content" [ngClass]="chat_lang === 'he' ? 'rtl text-end' : ''">
                                Events
                              </p>
                            }
                            @if (selected_index !== null && data.full_intervals_list && data.full_intervals_list[1] && data.full_intervals_list[1][selected_index] && data.full_intervals_list[1][selected_index].length > 0) {
                              <ul class="intervals-inline mt-3">
                                @for (full_interval of data.full_intervals_list[1][selected_index]; track full_interval; let i = $index) {
                                  <li class="interval-item list-group-item list-group-item-action list-group-item-secondary pointer badge-container" (click)="onTimestampClickSub(full_interval[0])">
                                    @if (data.full_intervals_list && data.full_intervals_list[2] && data.full_intervals_list[2][selected_index] && data.full_intervals_list[2][selected_index].length > 0) {
                                      <span class="badge bg-info">
                                        {{ sub_text_rename(data.full_intervals_list[2][selected_index][i]) }}
                                      </span>
                                    }
                                    {{ convertToTimerFormat(full_interval[0]) + ' - ' + convertToTimerFormat(full_interval[1]) }}
                                  </li>
                                }
                              </ul>
                            }
                            @if (!data.loading && data.continue) {
                              <hr>
                              }
                              @if (!data.loading && data.continue) {
                                <div class="btn-group shadow" ngbDropdown>
                                  <button type="button" class="btn btn-sm btn-primary dropdown-toggle" ngbDropdownToggle>Can I help you with something else?</button>
                                  <div class="dropdown-menu" ngbDropdownMenu>
                                    @for (button of data.continue; track button) {
                                      <a class="btn btn-info dropdown-item" (click)="handleButtonClick(button)">
                                        {{ button.name }}
                                        @if (button.description) {
                                          <i class="ri-information-fill align-bottom" [ngbTooltip]="button.description"></i>
                                        }
                                      </a>
                                    }
                                  </div>
                                </div>
                              }
                              @if (data.loading) {
                                <app-loading-spinner [spinner]="3" [size]="1"></app-loading-spinner>
                              }
                            </div>
                          </div>
                          <div class="conversation-name">
                            <small class="text-muted time">{{ data.timestamp | date:'short' }}</small>
                            <span class="text-success check-message-icon">
                              <i class="ri-check-double-line align-bottom"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  }
                </ul>
              </ngx-simplebar>
            </div>
          </div>
        </div>
      </div>
    </div>